export default function useHeadMeta(metadata, schemas = []) {
	const siteUrl = "https://www.opero.cz";

	const url = `${siteUrl}/${metadata.url || ""}`.replace(/\/+$/, "");

  const canonicalUrl = metadata.canonical
		? metadata.canonical.startsWith("http")
			? metadata.canonical
			: `${siteUrl}${metadata.canonical}`
		: new URL(url || useRoute().fullPath, siteUrl);

	canonicalUrl.search = "";
	canonicalUrl.hash = "";

	const breadcrumbs = [];
  var links = [];

  if (metadata.enUrl && metadata.csUrl) {
    links = [
      {
        rel: "alternate",
        hreflang: "cs",
        href: `${siteUrl}/${metadata.csUrl || ""}`.replace(/\/+$/, ""),
      },
      {
        rel: "alternate",
        hreflang: "en",
        href: `${siteUrl}/${metadata.enUrl || ""}`.replace(/\/+$/, ""),
      },
      {
        rel: "alternate",
        hreflang: "x-default",
        href: `${siteUrl}/${metadata.csUrl || ""}`.replace(/\/+$/, ""),
      },
    ];
  }

  links.push({
    rel: "canonical",
    href: canonicalUrl.toString().replace(/\/+$/, "").replaceAll('.cz//', '.cz/'),
  });

	// Always start with Home
	breadcrumbs.push({
		"@type": "ListItem",
		"position": 1,
		"name": "Home",
		"item": siteUrl,
	});

	// Add intermediate breadcrumbs
	(metadata.breadcrumbs || []).forEach((breadcrumb, index) => {
		const breadcrumbUrl = breadcrumb.item.startsWith("http")
			? breadcrumb.item
			: `${siteUrl}${breadcrumb.item}`;

		breadcrumbs.push({
			"@type": "ListItem",
			"position": index + 2,
			"name": breadcrumb.name,
			"item": breadcrumbUrl,
		});
	});

	// Add current page as final breadcrumb
	if (metadata.url && metadata.url !== "/") {
		breadcrumbs.push({
			"@type": "ListItem",
			"position": breadcrumbs.length + 1,
			"name": metadata.title,
			"item": url.replaceAll('.cz//', '.cz/'),
		});
	}

	const graph = [
		{
			"@id": "#company",
      "@type": "LocalBusiness",
      "name": "Opero",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Salvátorská 931/8",
        "addressLocality": "Praha 1",
        "addressRegion": "Praha",
        "postalCode": "11000",
        "addressCountry": "CZ",
        "telephone": "+420 777 167 376"
      },
      "image": "https://be.opero.cz/wp-content/uploads/2025/08/2022-08-30-Opero-0040.jpg",
			"priceRange": "$$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "08:00",
          "closes": "20:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Saturday",
            "Sunday"
          ],
          "description": "Otevřeno po domluvě"
        }
      ]
		},

		...(metadata.url && metadata.url !== "/"
			? [
				{
					"@id": "#breadcrumbs",
					"@type": "BreadcrumbList",
					"itemListElement": breadcrumbs,
				},
			]
			: []),

		...schemas,
	];

	useHead({
		title: metadata.title || null,

    link: links,

		meta: [
			{
				name: "description",
				content: metadata.description || null,
			},
			{
				name: "keywords",
				content: metadata.keywords || null,
			},
			{
				property: "og:url",
				content: url.replaceAll('.cz//', '.cz/'),
			},
			{
				property: "og:title",
				content: metadata.title || null,
			},
			{
				property: "og:description",
				content: metadata.description || null,
			},
			{
				property: "og:image",
				content: metadata.image || null,
			},
			{
				property: "twitter:url",
				content: url.replaceAll('.cz//', '.cz/'),
			},
			{
				property: "twitter:title",
				content: metadata.title || null,
			},
			{
				property: "twitter:description",
				content: metadata.description || null,
			},
			{
				property: "twitter:image",
				content: metadata.image || null,
			},
		],

		script: [
			{
				type: "application/ld+json",
				children: JSON.stringify({
					"@context": "https://schema.org",
					"@graph": graph,
				}, null, 2),
			},
		],
	});
}